import React from 'react';
import BillingSummary from '../components/BillingSummary';
import BillingTable from '../components/BillingTable';
import QuickActions from '../components/QuickActions';
import BillingChart from '../components/BillingChart';

const BillingPage = () => {
  return (
    <>
      <BillingSummary />
      <BillingTable />
      <QuickActions />
      <BillingChart />
    </>
  );
};

export default BillingPage;